var map = {
	"./building-0.png": "176b",
	"./building-1.png": "15d4",
	"./building-2.png": "1df3",
	"./building-3.png": "ff77",
	"./building-4.png": "2b0d",
	"./building-feature-h-0.png": "f93b",
	"./building-feature-h-1.png": "af19",
	"./building-feature-ky-0.png": "0c12",
	"./building-feature-ky-1.png": "5086"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "40bd";